import { CharacterBase } from '@/models/character';

export const rawCharacters: CharacterBase[] = [
  {
    characterStatistics: {
      id: 27,
      weight: 104,
      gravity: 2.9,
      walkSpeed: 0.85,
      runSpeed: 2.3,
      waveDashLengthRank: 20,
      plaIntangibilityFrames: 10,
      jumpSquat: 4,
      canWallJump: true,
      notes: '',
      initialDash: 2.16,
      dashFrames: 15,
      waveDashLength: 27.3,
    },
    name: 'Captain Falcon',
    normalizedName: 'captainfalcon',
    fightCoreId: 227,
  },
  {
    characterStatistics: {
      id: 28,
      weight: 85,
      gravity: 2.4,
      walkSpeed: 1.2,
      runSpeed: 1.61,
      waveDashLengthRank: 6,
      plaIntangibilityFrames: 5,
      jumpSquat: 5,
      canWallJump: false,
      notes: '',
      initialDash: 1.47,
      dashFrames: 15,
      waveDashLength: 38.97,
    },
    name: 'Roy',
    normalizedName: 'roy',
    fightCoreId: 223,
  },
  {
    characterStatistics: {
      id: 29,
      weight: 55,
      gravity: 1.9,
      walkSpeed: 1.24,
      runSpeed: 1.72,
      waveDashLengthRank: 22,
      plaIntangibilityFrames: 15,
      jumpSquat: 3,
      canWallJump: true,
      notes: '',
      initialDash: 1.72,
      dashFrames: 13,
      waveDashLength: 24.4,
    },
    name: 'Pichu',
    normalizedName: 'pichu',
    fightCoreId: 221,
  },
  {
    characterStatistics: {
      id: 30,
      weight: 94,
      gravity: 1.83,
      walkSpeed: 0.84,
      runSpeed: 1.4,
      waveDashLengthRank: 11,
      plaIntangibilityFrames: 4,
      jumpSquat: 4,
      canWallJump: false,
      notes: '',
      initialDash: 1.39,
      dashFrames: 13,
      waveDashLength: 36.18,
    },
    name: 'Ness',
    normalizedName: 'ness',
    fightCoreId: 243,
  },
  {
    characterStatistics: {
      id: 31,
      weight: 60,
      gravity: 1.7,
      walkSpeed: 1.1,
      runSpeed: 1.5,
      waveDashLengthRank: 7,
      plaIntangibilityFrames: 9,
      jumpSquat: 4,
      canWallJump: false,
      notes: '',
      initialDash: 1.5,
      dashFrames: 8,
      waveDashLength: 37.92,
    },
    name: 'Mr. Game & Watch',
    normalizedName: 'mrgame&watch',
    fightCoreId: 219,
  },
  {
    characterStatistics: {
      id: 32,
      weight: 85,
      gravity: 1.5,
      walkSpeed: 1.0,
      runSpeed: 1.4,
      waveDashLengthRank: 3,
      plaIntangibilityFrames: 1,
      jumpSquat: 5,
      canWallJump: false,
      notes: '',
      initialDash: 1.4,
      dashFrames: 18,
      waveDashLength: 55.69,
    },
    name: 'Mewtwo',
    normalizedName: 'mewtwo',
    fightCoreId: 217,
  },
  {
    characterStatistics: {
      id: 33,
      weight: 104,
      gravity: 2.13,
      walkSpeed: 1.2,
      runSpeed: 1.3,
      waveDashLengthRank: 24,
      plaIntangibilityFrames: 9,
      jumpSquat: 6,
      canWallJump: false,
      notes: '',
      initialDash: 1.3,
      dashFrames: 12,
      waveDashLength: 24.4,
    },
    name: 'Link',
    normalizedName: 'link',
    fightCoreId: 238,
  },
  {
    characterStatistics: {
      id: 34,
      weight: 117,
      gravity: 1.9,
      walkSpeed: 0.65,
      runSpeed: 1.5,
      waveDashLengthRank: 13,
      plaIntangibilityFrames: 8,
      jumpSquat: 8,
      canWallJump: false,
      notes: '',
      initialDash: 1.06,
      dashFrames: 13,
      waveDashLength: 35.49,
    },
    name: 'Bowser',
    normalizedName: 'bowser',
    fightCoreId: 241,
  },
  {
    characterStatistics: {
      id: 35,
      weight: 70,
      gravity: 1.6,
      walkSpeed: 0.85,
      runSpeed: 1.4,
      waveDashLengthRank: 20,
      plaIntangibilityFrames: 12,
      jumpSquat: 3,
      canWallJump: false,
      notes: '',
      initialDash: 1.4,
      dashFrames: 12,
      waveDashLength: 27.3,
    },
    name: 'Kirby',
    normalizedName: 'kirby',
    fightCoreId: 210,
  },
  {
    characterStatistics: {
      id: 36,
      weight: 109,
      gravity: 2.0,
      walkSpeed: 0.73,
      runSpeed: 1.35,
      waveDashLengthRank: 16,
      plaIntangibilityFrames: 4,
      jumpSquat: 6,
      canWallJump: false,
      notes: '',
      initialDash: 1.35,
      dashFrames: 15,
      waveDashLength: 30.9,
    },
    name: 'Ganondorf',
    normalizedName: 'ganondorf',
    fightCoreId: 216,
  },
  {
    characterStatistics: {
      id: 37,
      weight: 114,
      gravity: 2.4,
      walkSpeed: 1.2,
      runSpeed: 1.6,
      waveDashLengthRank: 17,
      plaIntangibilityFrames: 7,
      jumpSquat: 5,
      canWallJump: false,
      notes: '',
      initialDash: 1.6,
      dashFrames: 15,
      waveDashLength: 30.15,
    },
    name: 'Donkey Kong',
    normalizedName: 'donkeykong',
    fightCoreId: 242,
  },
  {
    characterStatistics: {
      id: 38,
      weight: 100,
      gravity: 1.7,
      walkSpeed: 1.1,
      runSpeed: 1.5,
      waveDashLengthRank: 7,
      plaIntangibilityFrames: 13,
      jumpSquat: 4,
      canWallJump: true,
      notes: '',
      initialDash: 1.5,
      dashFrames: 10,
      waveDashLength: 37.92,
    },
    name: 'Mario',
    normalizedName: 'mario',
    fightCoreId: 236,
  },
  {
    characterStatistics: {
      id: 39,
      weight: 100,
      gravity: 1.7,
      walkSpeed: 1.1,
      runSpeed: 1.5,
      waveDashLengthRank: 7,
      plaIntangibilityFrames: 14,
      jumpSquat: 4,
      canWallJump: false,
      notes: '',
      initialDash: 1.5,
      dashFrames: 10,
      waveDashLength: 37.92,
    },
    name: 'Dr. Mario',
    normalizedName: 'drmario',
    fightCoreId: 215,
  },
  {
    characterStatistics: {
      id: 40,
      weight: 100,
      gravity: 1.6,
      walkSpeed: 1.1,
      runSpeed: 1.34,
      waveDashLengthRank: 1,
      plaIntangibilityFrames: 13,
      jumpSquat: 4,
      canWallJump: false,
      notes: '',
      initialDash: 1.34,
      dashFrames: 10,
      waveDashLength: 91.12,
    },
    name: 'Luigi',
    normalizedName: 'luigi',
    fightCoreId: 213,
  },
  {
    characterStatistics: {
      id: 41,
      weight: 108,
      gravity: 1.93,
      walkSpeed: 1.15,
      runSpeed: 1.6,
      waveDashLengthRank: 5,
      plaIntangibilityFrames: 2,
      jumpSquat: 5,
      canWallJump: false,
      notes: '',
      initialDash: 1.43,
      dashFrames: 13,
      waveDashLength: 38.97,
    },
    name: 'Yoshi',
    normalizedName: 'yoshi',
    fightCoreId: 211,
  },
  {
    characterStatistics: {
      id: 42,
      weight: 88,
      gravity: 1.6,
      walkSpeed: 0.95,
      runSpeed: 1.4,
      waveDashLengthRank: 2,
      plaIntangibilityFrames: 13,
      jumpSquat: 3,
      canWallJump: false,
      notes: '',
      initialDash: 1.4,
      dashFrames: 13,
      waveDashLength: 62.785,
    },
    name: 'Ice Climbers',
    normalizedName: 'iceclimbers',
    fightCoreId: 209,
  },
  {
    characterStatistics: {
      id: 43,
      weight: 80,
      gravity: 1.9,
      walkSpeed: 1.24,
      runSpeed: 1.8,
      waveDashLengthRank: 19,
      plaIntangibilityFrames: 13,
      jumpSquat: 3,
      canWallJump: false,
      notes: '',
      initialDash: 1.8,
      dashFrames: 13,
      waveDashLength: 26.82,
    },
    name: 'Pikachu',
    normalizedName: 'pikachu',
    fightCoreId: 237,
  },
  {
    characterStatistics: {
      id: 44,
      weight: 90,
      gravity: 1.5,
      walkSpeed: 0.85,
      runSpeed: 1.3,
      waveDashLengthRank: 25,
      plaIntangibilityFrames: 0,
      jumpSquat: 5,
      canWallJump: false,
      notes: '',
      initialDash: 1.3,
      dashFrames: 15,
      waveDashLength: 22.42,
    },
    name: 'Peach',
    normalizedName: 'peach',
    fightCoreId: 240,
  },
  {
    characterStatistics: {
      id: 45,
      weight: 90,
      gravity: 2.13,
      walkSpeed: 1.2,
      runSpeed: 1.8,
      waveDashLengthRank: 18,
      plaIntangibilityFrames: 11,
      jumpSquat: 3,
      canWallJump: true,
      notes: '',
      initialDash: 1.8,
      dashFrames: 7,
      waveDashLength: 30.15,
    },
    name: 'Sheik',
    normalizedName: 'sheik',
    fightCoreId: 260,
  },
  {
    characterStatistics: {
      id: 46,
      weight: 110,
      gravity: 1.4,
      walkSpeed: 1.0,
      runSpeed: 1.4,
      waveDashLengthRank: 10,
      plaIntangibilityFrames: 4,
      jumpSquat: 3,
      canWallJump: true,
      notes: '',
      initialDash: 1.8,
      dashFrames: 8,
      waveDashLength: 37.92,
    },
    name: 'Samus',
    normalizedName: 'samus',
    fightCoreId: 212,
  },
  {
    characterStatistics: {
      id: 47,
      weight: 60,
      gravity: 1.3,
      walkSpeed: 0.7,
      runSpeed: 1.1,
      waveDashLengthRank: 23,
      plaIntangibilityFrames: 9,
      jumpSquat: 5,
      canWallJump: false,
      notes: '',
      initialDash: 1.31,
      dashFrames: 12,
      waveDashLength: 24.12,
    },
    name: 'Jigglypuff',
    normalizedName: 'jigglypuff',
    fightCoreId: 214,
  },
  {
    characterStatistics: {
      id: 48,
      weight: 87,
      gravity: 2.2,
      walkSpeed: 1.6,
      runSpeed: 1.8,
      waveDashLengthRank: 4,
      plaIntangibilityFrames: 4,
      jumpSquat: 4,
      canWallJump: false,
      notes: '',
      initialDash: 1.56,
      dashFrames: 15,
      waveDashLength: 44.37,
    },
    name: 'Marth',
    normalizedName: 'marth',
    fightCoreId: 222,
  },
  {
    characterStatistics: {
      id: 49,
      weight: 75,
      gravity: 2.8,
      walkSpeed: 1.6,
      runSpeed: 2.2,
      waveDashLengthRank: 12,
      plaIntangibilityFrames: 15,
      jumpSquat: 3,
      canWallJump: true,
      notes: '',
      initialDash: 2.02,
      dashFrames: 11,
      waveDashLength: 32.85,
    },
    name: 'Fox',
    normalizedName: 'fox',
    fightCoreId: 224,
  },
  {
    characterStatistics: {
      id: 50,
      weight: 80,
      gravity: 3.1,
      walkSpeed: 1.4,
      runSpeed: 1.5,
      waveDashLengthRank: 14,
      plaIntangibilityFrames: 14,
      jumpSquat: 5,
      canWallJump: true,
      notes: '',
      initialDash: 1.82,
      dashFrames: 11,
      waveDashLength: 31.42,
    },
    name: 'Falco',
    normalizedName: 'falco',
    fightCoreId: 218,
  },
  {
    characterStatistics: {
      id: 51,
      weight: 85,
      gravity: 2.13,
      walkSpeed: 1.2,
      runSpeed: 1.6,
      waveDashLengthRank: 15,
      plaIntangibilityFrames: 13,
      jumpSquat: 4,
      canWallJump: true,
      notes: '',
      initialDash: 1.72,
      dashFrames: 12,
      waveDashLength: 30.15,
    },
    name: 'Young Link',
    normalizedName: 'younglink',
    fightCoreId: 220,
  },
  {
    characterStatistics: {
      id: 52,
      weight: 90,
      gravity: 1.4,
      walkSpeed: 0.7,
      runSpeed: 1.1,
      waveDashLengthRank: 25,
      plaIntangibilityFrames: 2,
      jumpSquat: 6,
      canWallJump: false,
      notes: '',
      initialDash: 1.1,
      dashFrames: 15,
      waveDashLength: 21.73,
    },
    name: 'Zelda',
    normalizedName: 'zelda',
    fightCoreId: 239,
  },
  {
    characterStatistics: {
      id: 53,
      weight: 0,
      gravity: 0.0,
      walkSpeed: 0.0,
      runSpeed: 0.0,
      waveDashLengthRank: 0,
      plaIntangibilityFrames: 0,
      jumpSquat: 0,
      canWallJump: false,
      notes: 'No data available yet',
      initialDash: 0.0,
      dashFrames: 0,
      waveDashLength: 0.0,
    },
    name: 'Female Wireframe',
    normalizedName: 'fwireframe',
    fightCoreId: 0,
  },
];

const sortFunction = (characterOne: { name: string }, characterTwo: { name: string }) =>
  characterOne.name > characterTwo.name ? 1 : -1;

export const characters = rawCharacters.sort(sortFunction);
